import { Box } from "@mui/material";
import MContainer from "@mui/material/Container";
import MLinearProgress, { linearProgressClasses } from "@mui/material/LinearProgress";
import { styled } from "@mui/material/styles";

export const Container = styled(MContainer)({
  height: "99vh",
  width: "99vw",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
});

export const BoxContainer = styled(Box)(() => ({
  width: "100px",
}));
export const BorderLinearProgress = styled(MLinearProgress)(({ theme }) => ({
  height: 6,
  borderRadius: 12,
  [`&.${linearProgressClasses.colorPrimary}`]: {
    backgroundColor: theme.palette.secondary.main,
  },
  [`& .${linearProgressClasses.bar}`]: {
    borderRadius: 5,
    backgroundColor: theme.palette.primary.main,
  },
}));
